'use client';

import 'react';
import getElementClientRect from '../helpers/getElementClientRect.js';

function getOpositePlacement(placement) {
    switch (placement) {
        case 'top-start':
            return 'bottom-start';
        case 'top':
            return 'bottom';
        case 'top-end':
            return 'bottom-end';
        case 'right-start':
            return 'left-start';
        case 'right':
            return 'left';
        case 'right-end':
            return 'left-end';
        case 'left-start':
            return 'right-start';
        case 'left':
            return 'right';
        case 'left-end':
            return 'right-end';
        case 'bottom-start':
            return 'top-start';
        case 'bottom':
            return 'top';
        case 'bottom-end':
            return 'top-end';
    }
}
function shouldFlip(_a) {
    var placement = _a.placement, offset = _a.offset, referenceRect = _a.referenceRect, popupRect = _a.popupRect, scrollableParent = _a.scrollableParent;
    var scrollableParentRect = getElementClientRect(scrollableParent);
    var popupHeight = popupRect.height;
    var referenceHeight = referenceRect.height;
    var popupWidth = popupRect.width;
    var referenceWidth = referenceRect.width;
    /*
     * Calculate the top, right bottom, left of popup if it touch the limit
     * of scrollable parent
     * */
    var top = referenceRect.y - (popupHeight + offset);
    var bottom = referenceRect.y + referenceHeight + popupHeight + offset;
    var left = referenceRect.x - popupWidth - offset;
    var right = referenceRect.x + referenceWidth + popupWidth + offset;
    switch (placement) {
        case 'top-start':
        case 'top':
        case 'top-end':
            return top < scrollableParentRect.top;
        case 'bottom-start':
        case 'bottom':
        case 'bottom-end':
            return bottom > scrollableParentRect.bottom;
        case 'left-start':
        case 'left':
        case 'left-end':
            return left < scrollableParentRect.left;
        case 'right-start':
        case 'right':
        case 'right-end':
            return right > scrollableParentRect.right;
    }
}
function flip(_a) {
    var reference = _a.reference, popup = _a.popup, scrollableParents = _a.scrollableParents, placement = _a.placement, popupConfigs = _a.popupConfigs;
    var _b = popupConfigs || {}, _c = _b.offset, offset = _c === void 0 ? 0 : _c, _d = _b.isFlip, isFlip = _d === void 0 ? true : _d, _e = _b.useWindowAsFlippingContainer, useWindowAsFlippingContainer = _e === void 0 ? false : _e;
    /*
     * Return immediately if flip doesn't enable
     * */
    if (!isFlip || scrollableParents.size === 0) {
        return placement;
    }
    var returnPlacement = placement;
    var getScrollableParents = scrollableParents;
    if (useWindowAsFlippingContainer) {
        getScrollableParents = new Set([window]);
    }
    var referenceRect = reference.getBoundingClientRect();
    var popupRect = popup.getBoundingClientRect();
    getScrollableParents.forEach(function (scrollableParent) {
        if (shouldFlip({
            placement: placement,
            referenceRect: referenceRect,
            popupRect: popupRect,
            offset: offset,
            scrollableParent: scrollableParent
        })) {
            returnPlacement = getOpositePlacement(placement);
        }
    });
    return returnPlacement;
}

export { flip as default };
//# sourceMappingURL=flip.js.map
